/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, date: NonNullable<unknown> }} Receipt_Seats_AddedInputs */



/**
* | output |
* | --- |
* | "+{count} seats from {date}" |
*
* @param {Receipt_Seats_AddedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_seats_added = /** @type {((inputs: Receipt_Seats_AddedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Seats_AddedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`+${i?.count} Plätze ab ${i?.date}`)
	return /** @type {LocalizedString} */ (`+${i?.count} seats from ${i?.date}`)
});